module.exports = __webpack_public_path__ + "static/media/TwitterSpeechSmall.4a9a2c32.svg";